/** Production Next.js API host. Override with REACT_APP_API_BASE_URL (e.g. http://localhost:3000 for local). */
export const DEFAULT_API_ORIGIN = "https://abaarso.taamsolutions.net";

export const API_BASE = (
  (process.env.REACT_APP_API_BASE_URL &&
    String(process.env.REACT_APP_API_BASE_URL).trim()) ||
  DEFAULT_API_ORIGIN
).replace(/\/$/, "");
